/**
 * Categories Page
 */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoryService } from '../services/api';
import './CategoriesPage.css';

function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    categoryService.getAll()
      .then(res => setCategories(res.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="categories-page">
      <div className="container">
        <div className="page-header">
          <h1>Algorithm Categories</h1>
          <p>Explore algorithms organized by OS curriculum units</p>
        </div>

        {loading && <div className="loader"><div className="spinner" /></div>}

        {!loading && (
          <div className="cat-detail-grid">
            {categories.map(cat => (
              <div key={cat.id} className="cat-detail-card card" style={{ '--cat-color': cat.color }}>
                {/* Header */}
                <div className="cat-detail-header" style={{ borderLeft: `4px solid ${cat.color}` }}>
                  <div className="cat-detail-icon" style={{ background: `${cat.color}22`, color: cat.color }}>
                    {cat.icon}
                  </div>
                  <div>
                    <span className="cat-detail-unit">{cat.unit}</span>
                    <h2>{cat.name}</h2>
                  </div>
                </div>

                <p className="cat-detail-desc">{cat.description}</p>

                {/* Topics */}
                <div className="cat-topics">
                  <h4>Topics Covered</h4>
                  <div className="topics-list">
                    {cat.topics.map(topic => (
                      <span key={topic} className="topic-chip">{topic}</span>
                    ))}
                  </div>
                </div>

                {/* Footer */}
                <div className="cat-detail-footer">
                  <span className="cat-algo-count">
                    {cat.algorithmCount} algorithms
                  </span>
                  <Link
                    to={`/algorithms?category=${cat.id}`}
                    className="btn btn-primary btn-sm"
                    style={{ background: cat.color }}
                  >
                    Browse Algorithms →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoriesPage;
